import { fontList } from '../../core/font-list';
import { colorListPairs, colorMap, colorListCharts } from '../../core/color-list';

export let params = {
  'category': 'animation',
  'parameters': {
    'size': {
      'default': {
        'key': '900 x 600',
        'value': [900, 600],
        'label': '900 x 600'
      },
      'label': 'Afmeting',
      'type': 'array',
      'values': [
        {
          'key': '600 x 900',
          'value': [600, 900],
          'label': '600 x 900'
        },
      ],
      'control': 'standard-select',
      'description': 'Afmeting van de visualisatie',
    },
    'width': {
      'default': 900,
      'label': 'Breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'height': {
      'default': 600,
      'label': 'Hoogte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleText': {
      'default':  'Umsatz und Anzahl\nvon Beschäftigten\nsteigen im ersten\nKwartal 2018',
      'label': 'Titel tekst',
      'type': 'string',
      'control': 'standard-control',
    },
    'textFontSize': {
      'default': 32,
      'label': 'Font grootte tekst',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'textLineHeight': {
      'default': 1.7,
      'label': 'Regelhoogte tekst',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'textFontColor': {
      'default': '#222221',
      'label': 'Font kleur tekst',
      'type': 'string',
      'control': 'standard-control',
    },
    'textFontSizeDelta': {
      'default': 0,
      'label': 'Tekst font grootte delta',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Vergroting / verkleining van de lettergrootte van de tekst',
    },
    'numberFontSizeDelta': {
      'default': 10,
      'label': 'Getal font grootte delta met tekst',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Vergroting / verkleining van het getal in regel 1 tov de grootte van de tekst',
    },
    'colorScheme': {
      'default': {
        'key': 'grijs',
        'label': 'Grijs',
        'value': ['#871d33', '#eeefef'],
      },
      'control': 'cbs-color-scheme',
    },
    'marginLeft': {
      'default': 30,
      'label': 'Linkermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginRight': {
      'default': 30,
      'label': 'Rechtermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'paddingRight': {
      'default': 30,
      'label': 'Rechtermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginTop': {
      'default': 40,
      'label': 'Bovenmarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginBottom': {
      'default': 40,
      'label': 'Ondermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'paddingBottom': {
      'default': 0,
      'label': 'Rechtermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'logoY': {
      'default': 200,
      'label': 'Logo Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'logoWidth': {
      'default': 300,
      'label': 'Breedte logo',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'iconColor': {
      'default': '#FFFFFF',
      'label': 'iconColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'iconOpacity': {
      'default': 1,
      'label': 'iconOpacity',
      'type': 'number',
      'control': 'standard-number',
    },
    'iconX': {
      'default': 550,
      'label': 'iconX',
      'type': 'number',
      'control': 'standard-number',
    },
    'iconY': {
      'default': 260,
      'label': 'iconY',
      'type': 'number',
      'control': 'standard-number',
    },
    'bannerHeight': {
      'default': 130,
      'label': 'Banner height',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleOffsetX': {
      'default': 17,
      'label': 'Titel afstand X',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleOffsetY': {
      'default': 210,
      'label': 'Titel afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'title1OffsetY': {
      'default': 15,
      'label': 'Titel 1 afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'title2OffsetY': {
      'default': 60,
      'label': 'Titel 2 afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleText1': {
      'default': 'Umsatz und Beschäftigte im Einzelhandel von Januar bis März 2018',
      'label': 'Titel tekst 1',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleText2': {
      'default': 'Veränderung gegenüber Januar bis März 2017 in %',
      'label': 'Titel tekst 2',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleColor': {
      'default': '#FFFFFF',
      'label': 'Titel kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleFontSize': {
      'default': 48,
      'label': 'Titel font grootte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'title1Color': {
      'default': '#871d33',
      'label': 'Titel kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'title1FontSize': {
      'default': 25,
      'label': 'Titel font grootte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'title2Color': {
      'default': '#871d33',
      'label': 'Titel kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'title2FontSize': {
      'default': 21,
      'label': 'Titel font grootte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleFontWeight': {
      'default': 700,
      'label': 'Titel font dikte',
      'type': 'numeric',
      'control': 'standard-control',
    },
    'minY': {
      'default': 0,
      'label': 'Min Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'maxY': {
      'default': 3.5,
      'label': 'Max Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'steps': {
      'default': 7,
      'label': 'Steps',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Aantal horizontale lijnen excl. as',
    },
    'unitText': {
      'default': '',
      'label': 'Tekst eenheid',
      'type': 'string',
      'control': 'standard-control',
    },
    'unitTextOffsetY': {
      'default': 30,
      'label': 'Afstand unit boven max',
      'type': 'string',
      'control': 'standard-control',
    },
    'footerText': {
      'default': '1 Ohne Handel mit Kraftfahrzeugen',
      'label': 'Tekst footer',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelSpaceY': {
      'default': 55,
      'label': 'Label ruimte Y',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Ruimte voor de labelteksten langs de Y-as',
    },
    'labelSpaceX': {
      'default': 50,
      'label': 'Label ruimte X',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelColor': {
      'default': '#777878',
      'label': 'Label kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelFontSize': {
      'default': 15,
      'label': 'Label font grootte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelFontFamily': {
      'default': 'Arial, Helvetica Neue, Helvetica, Roboto, sans-serif',
      'label': 'Label font-size',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelOffsetY': {
      'default': 10,
      'label': 'Label afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand tussen de labels en de Y-as',
    },
    'labelOffsetX': {
      'default': 15,
      'label': 'Label afstand X',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legend': {
      'default': true,
      'label': 'Show legend',
      'type': 'boolean',
      'control': 'standard-checkbox',
    },
    'legendRows': {
      'default': 1,
      'label': 'Aantal rijen in de legend',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendItemWidth' : {
      'default': 15,
      'label': 'Breede van het legend item',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Is de breede van het ledgend item voor de tekst',
    },
    'legendOffsetY' : {
      'default': 405,
      'label': 'Y offset legenda',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Offset van de legends naar de grafiek erboven',
    },
    'legendSpaceBetweenColumns' : {
      'default': 180,
      'label': 'Breede legenda',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendItemDistance' : {
      'default': 30,
      'label': 'Afstand tussen de legenda items',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendFontSize' : {
      'default': 20,
      'label': 'Lettergrotte in de legenda',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'ledgendSpaceBetweenItemAndText':
     {
      'default': 8,
      'label': 'Afstand tussen item en tekst in legenda',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'formatLocale': {
      'default': {
        'key': 'nl-nl',
        'value': 'nl-nl',
        'label': 'Nederlands'
      },
      'label': 'Taal',
      'type': 'string',
      'values' : [
        {
          'key': 'nl-nl',
          'value': 'nl-nl',
          'label': 'Nederlands'
        },
        {
          'key': 'en-gb',
          'value': 'en-gb',
          'label': 'Engels'
        }
      ],
      'control': 'standard-select',
      'description': 'Taal voor het formatteren van de Y-as labels',
    },
    'labelDecimalsY': {
      'default': '1',
      'label': 'Label decimalen y',
      'type': 'number',
      'control': 'standard-number',
      'description': 'Aantal cijfers achter de komma in de Y-as labels',
    },
    'leftLabelX': {
      'default': '55-59',
      'label': 'Linker label X',
      'type': 'string',
      'control': 'standard-control',
    },
    'middleLabelX': {
      'default': '60-64',
      'label': 'Linker label X',
      'type': 'string',
      'control': 'standard-control',
    },
    'rightLabelX': {
      'default': '65-69',
      'label': 'Rechter label X',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelBottom': {
      'default': 'Alter von ... bis ... Jahren',
      'label': 'Aanvullend label onderaan',
      'type': 'string',
      'control': 'standard-control',
    },
    'axisStroke': {
      'default': '#222221',
      'label': 'As kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'axisStrokeWidth': {
      'default': 3,
      'label': 'As breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'barColor': {
      'default': ['#871d33', '#0073a4'],
      'label': 'Staaf kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'barStrokeColor': {
      'default': '#011c8b',
      'label': 'Staaf rand kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'barStrokeWidth': {
      'default': 0,
      'label': 'Staaf rand breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'barPadding': {
      'default': 0.2,
      'label': 'Staaf tussenafstand',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Gedeelte van de grafiekbreedte gereserveerd voor padding waarde tussen 0 en 1',
    },
    'barPaddingInner': {
      'default': 60,
      'label': 'Staaf tussenafstand',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'padding tussen de staven',
    },
    'barAnimation': {
      'default': {
        'key': 'allAtOnce',
        'value': 'allAtOnce',
        'label': 'Alle staven tegelijk'
      },
      'label': 'Staaf animatie',
      'type': 'string',
      'values': [
        {
          'key': 'allAtOnce',
          'value': 'allAtOnce',
          'label': 'Alle staven tegelijk'
        },
        {
          'key': 'oneAfterTheOther',
          'value': 'oneAfterTheOther',
          'label': 'Staven één voor één'
        }
      ],
      'control': 'standard-select',
      'description': 'Animatie van de staven',
    },
    'iconWidth': {
      'default': 140,
      'label': 'Icoon breedte',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Breedte van het icoon',
    },
    'iconStrokeWidth': {
      'default': 3,
      'label': 'Icoon font dikte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'iconOffsetDeltaX': {
      'default': 0,
      'label': 'Icoon afstand delta X',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Verschuiving van het icoon in de x-richting',
    },
    'iconOffsetDeltaY': {
      'default': 0,
      'label': 'Icoon afstand delta Y',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Verschuiving van het icoon in de x-richting',
    },
    'iconOffsetX': {
      'default': 440,
      'label': 'Icoon afstand X',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand van het icoon t.o.v. de linkerkant',
    },
    'iconOffsetY': {
      'default': 35,
      'label': 'Icoon afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand van het icoon t.o.v. de bovenkant',
    },
  },
  'timings': {
    'pauseBar': {
      'default': 2,
      'label': 'Pause tussen bar en coloranimation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseSlide1': {
      'default': 5,
      'label': 'Pause tussen de 1e en 2e slide',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'animateSteps': {
      'default': 0.5,
      'label': 'Animatie steps',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseSlide2': {
      'default': 3,
      'label': 'Pause slide 2',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide1Animation': {
      'default': 4,
      'label': 'Slide 1 animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide2Animation': {
      'default': 5,
      'label': 'Slide 2 animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'logoAnimation': {
      'default': 2,
      'label': 'Logo CBS animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseEnd': {
      'default': 5,
      'label': 'Pause aan het einde',
      'type': 'numeric',
      'control': 'standard-number'
    }
  },
  'data': {
    'values': [['', 'Rheinland-Pfalz', 'Deutschland'], ['Umsatz (nominal)', 2.2, 3.1], ['Umsatz (real)', 0.7, 1.7], ['Vollzeitbeschäftigte', 0.4, 0.8], ['Teilzeitbeschäftigte', 1.5, 1.1], ['Beschäftigte insgesamt', 1.1, 0.9]],
    'columnLimitMin': 1,
    'columnLimitMax': 1,
    'columnLabelNumber': 1,
    'rowLimitMin': 2,
    'rowLimitMax': 12,
    'rowLabelNumber': 1,
  },
  'parameterGroups': [
    {
      'title': 'Primair',
      'collapsed': false,
      'keys': []
     // 'keys': ['size','icon','titleText1', 'titleText2', 'text', 'minY', 'maxY', 'unitText', 'leftLabelX', 'rightLabelX'],
    },
    {
      'title': 'Secundair',
      'collapsed': true,
      'keys': []
     // 'keys': ['steps', 'formatLocale', 'labelDecimalsY', 'legendOffsetY', 'legendSpaceBetweenColumns','iconOffsetDeltaX','iconOffsetDeltaY'],
    }
  ],
  'timingGroups': [
    {
      'title': 'Timing',
      'collapsed': true,
      'keys': []
     // 'keys': ['slide1Animation','pauseSlide2','logoCBSAnimation', 'payoffCBSAnimation','pauseEnd']
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/animations/demo-rlp-triptych-bar-vert-steps/social.params.ts